<template>
	<label class="radio-container">
		<span class="radio-label mr-4" v-if="label">{{ label }}</span>
		<input 
			class="radio-input"
			type="radio"
			:checked="modelValue === value"
			:value="value"
			v-bind="$attrs"
			@change="$emit('update:modelValue', value)"
		/>
	</label>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			default: ''
		},
		modelValue: {
			type: [String, Number],
			default: ''
		},
		value: {
			type: [String, Number],
			required: true
		}
	}
}
</script>